import { useEffect } from "react";

import logError from "@utils/logError";
import { WebsiteContextProvider } from "@contexts/WebsiteContext";
import Card from "@elements/Card";
import MotionDiv from "@components/elements/MotionDiv";

import Page from "@components/page/Page";

const CONFIG = {
  title: "Error",
  displayPageHeader: true,
  contentWidth: "sm",
};

export default function ErrorPage(props) {
  const {
    error,
    _resetErrorBoundary,
  } = props;

  useEffect(() => {
    if (error) {
      console.error(error.message);
      window.rollbar.error(error);
      logError(error);
    }
  }, [error]);

  /**************************************************************************************************/

  return (
    <WebsiteContextProvider>
      <Page
        config={CONFIG}
      >
        <MotionDiv key="error" type="card">
          <Card
            className="text-center"
            content="Something went wrong!"
          />
        </MotionDiv>
      </Page>
    </WebsiteContextProvider>
  );
}
